<template>
<div>
  404 NOT FOUND
  <a href="/welcome">返回首页</a>
  <a href="/login">去登录</a>
</div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/error/NotFound.vue